import React from 'react';
import PropTypes from 'prop-types';

import styles from './FreeformForm.css';
import FormSubmissionControls from './FormSubmissionControls.js';
import RedactorTextArea from '../Redactor/RedactorTextArea.js';

const EMPTY_DATA = {
  title: '',
  subtitle: '',
  content: ''
};

class FreeformForm extends React.Component {
  constructor(props) {
    super(props);

    this.isValid = this.isValid.bind(this);
    this.onCancel =  this.onCancel.bind(this);
    this.onSubmit =  this.onSubmit.bind(this);
    this.onTextInputChange =  this.onTextInputChange.bind(this);

    this.state = Object.assign({
      formValidationText: ''
    }, props.data);
  }


  onTextInputChange(stateKey) {
    return (e) => {
      const text = e.target.value;
      this.setState({[stateKey]: text});
    };
  }

  onCancel() {
    this.setState(EMPTY_DATA);
    this.props.onCancel();
  }

  onSubmit() {
    if(! this.isValid()) {
      return; // early exit
    }
    if (this.props.isEditing) {
      const newData = Object.assign({
        categories: [
          'custom',
          'freeform'
        ],
        subtype: 'freeform',
        icon: 'AlignLeft'
      }, this.state);
      this.props.onSubmit(newData);
    }
    if (!this.props.isEditing) {
      this.redactorTextArea.processData((redactorContent) => {
        const newData = Object.assign({
          categories: [
            'custom',
            'freeform'
          ],
          subtype: 'freeform',
          icon: 'AlignLeft'
        }, this.state);
        newData.content = redactorContent;
        this.props.onSubmit(newData);
      });
    }
  }

  isValid() {
    const { title, content } = this.state;
    const validityMessages = [];

    if(title.length === 0) {
      validityMessages.push('Title is required');
    }
    if(content.length === 0) {
      validityMessages.push('Content is required');
    }

    const isValid = validityMessages.length === 0;
    if(! isValid) {
      this.setState({
        formValidationText: validityMessages.join('; ')
      });
    }

    return isValid;
  }

  render() {
    const { isEditing, fileUploadUrl } = this.props;
    const { formValidationText } = this.state;
    const component = this;

    const redactorOptions = {
      imageUpload: fileUploadUrl,
      imageResizable: true,
      imagePosition: true,
      focusEnd: true,
      linkTarget: '_blank',
      plugins: ['fontsize', 'alignment', 'fontcolor'],
      deniedTags: ['html', 'head', 'link', 'body', 'meta', 'script', 'style', 'applet'],
      buttons: [
        'format',
        'bold',
        'italic',
        'deleted',
        'ol',
        'ul',
        'indent',
        'outdent',
        'link',
        'image',
        'line'
      ],
      formatting: ['p', 'blockquote', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5'],
      callbacks: {
        changed: function change(html) {
          component.setState({content: html});
        }
      }
    };

    const formValidationMessage = (
      <p className={styles.formValidationMessage}>
        {formValidationText}
      </p>
    );

    return (
      <form>
        <p className={styles.description}>
          Freeform lets you create a widget with text, images, and some basic styling (lists, links, etc.)
        </p>

        <section>
          <div className={styles.formField}>
            <label className={styles.label}>Title</label>
            <input
              type="text"
              value={this.state.title}
              name="title"
              onChange={this.onTextInputChange('title')}
              className={styles.textInput}
            />
          </div>

          <div className={styles.formField}>
            <label className={styles.label}>Subtitle</label>
            <input
              type="text"
              value={this.state.subtitle}
              placeholder="Optional"
              name="subtitle"
              onChange={this.onTextInputChange('subtitle')}
              className={styles.textInput}
            />
          </div>

          <div className={styles.redactorFormField}>
            <label className={styles.label}>Content</label>
            <div className={styles.redactorWrapper}>
              <RedactorTextArea
                defaultValue={this.state.content}
                onBlur={this.onTextInputChange('content')}
                options={redactorOptions}
                ref={(e) => {this.redactorTextArea =e;}}
              />
            </div>
          </div>
        </section>

        {formValidationText.length > 0 ? formValidationMessage: null}

        <FormSubmissionControls
          onCancel={this.onCancel}
          onSubmit={this.onSubmit}
          submitButtonText={isEditing ? 'Save' : undefined}
        />
      </form>
    );
  }
}

FreeformForm.propTypes = {
  fileUploadUrl: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  data: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    content: PropTypes.string
  }),
  isEditing: PropTypes.bool
};

FreeformForm.defaultProps = {
  data: EMPTY_DATA,
  isEditing: false
};

export default FreeformForm;
